import { Link } from "react-router-dom";

export default function NatureFlowSignUp () {
    return (
        <>
        hi, coming soon
        </>
    )
}
